import React, { FC, useMemo } from 'react';

import { observer } from 'mobx-react';

import { Select } from '@/components/Common/UIKit';
import { useStores } from '@/components/hooks';
import { filterByLabel } from '@/components/utils';

interface PolicySelectProps {
    selectedPolicyId: string;
    onChange?: (policyId: string) => void | Promise<void>;
    className?: string;
    hasBuiltInBorders?: boolean;
    disabled?: boolean;
    fallbackOption?: { value: string; label: string };
}

const PolicySelect: FC<PolicySelectProps> = observer(({
    selectedPolicyId,
    onChange,
    className,
    disabled = false,
    fallbackOption,
}) => {
    const { policyStore: { policiesListToDropdown } } = useStores();

    const options = useMemo(() => {
        if (!fallbackOption || policiesListToDropdown.some((o) => o.value === fallbackOption.value)) {
            return policiesListToDropdown;
        }
        return [...policiesListToDropdown, fallbackOption]
            .sort((a, b) => (a.label?.toLowerCase() ?? '').localeCompare(b.label?.toLowerCase() ?? ''));
    }, [policiesListToDropdown, fallbackOption]);

    return (
        <form autoComplete="off" style={{ display: 'contents' }}>
            <Select<string>
                className={className}
                showSearch
                onChange={onChange}
                value={selectedPolicyId}
                options={options}
                filterOption={filterByLabel}
                disabled={disabled}
            />
        </form>
    );
});

export default PolicySelect;
